import api from '@/services/api';
import { defineStore } from 'pinia';

export const useMaterialTipoStore = defineStore('materialTipoStore', {
  state: () => ({
    materialTipoList: [],
    materialTipo: {},
    page: 1,
  }),
  actions: {
    async findAllMaterialTipoHTTP(filters = {}) {
      // this.setPage(1);
      const result = await api.get('/material-tipo', {
        params: { page: this.page, ...filters, sortBy: 'Descripcion', sort: 'asc', limit: 200 },
      });
      if (result && result.data) {
        this.materialTipoList.splice(0, this.materialTipoList.length, ...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async findMaterialTipoByCodigoHTTP(codigo) {
      try {
        const result = await api.get(`/material-tipo/${codigo}`);
        if (result && result.data) {
          const cfg = result.data;
          this.materialTipo[codigo] = cfg;
          return cfg;
        }
      } catch (error) {
        console.error('Error en findMaterialTipoByCodigoHTTP:', error);
        return {};
      }
    },
    async firstMaterialTipo(params) {
      this.setPage(params.page || 1);
      this.emptyList();
      await this.findAllMaterialTipoHTTP(params);
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.materialTipoList = [];
    },
  },
});
